<template>
    <div>
        <van-nav-bar title="参与记录" left-arrow @click-left="onClickLeft" />
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="record">
                <record-scroll url="shop/activity-lottery-log" :params="params">
                    <template slot-scope="scope">
                        <div class="record_item" v-for="(row,i) in scope.data" key="i">
                            <div class="ri">
                                <div class="prefix">奖品</div>
                                <div class="suffix">{{ row.gift_name }}</div>
                            </div>
                            <div class="ri">
                                <div class="prefix">获奖时间</div>
                                <div class="suffix">{{ row.create_time.slice(0,16) }}</div>
                            </div>
                            <div class="ri">
                                <div class="prefix">状态</div>
                                <div class="suffix">
                                    <span class="status" v-if="row.status == 1">待领取</span>
                                    <span class="status" v-else-if="row.status == 2">待发货</span>
                                    <span class="status" v-else-if="row.status == 3">待收货</span>
                                    <span class="status" v-else-if="row.status == 4">已完成</span>
                                </div>
                            </div>
                            <!-- <div class="ri">
                            <div class="prefix">操作</div>
                            <div class="suffix"></div>
                        </div> -->
                            <div class="ri" v-if="row.cdk != ''">
                                <div class="prefix">兑换码</div>
                                <div class="suffix cdk">
                                    <span class="cdk_num">{{ row.cdk }}</span>
                                    <span class="fz" @click="copy(row.cdk)">复制</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </record-scroll>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                params: {
                    lotteryId: this.$route.query.lottery_id
                }
            }
        },
        methods: {
            copy(cdk) {
                var that = this
                this.$copyText(cdk).then(() => {
                    that.$Message.success("复制成功");
                });
            }
        },
    }
</script>

<style lang="less" scoped>
    .record {
        margin-top: 2.5rem;
        padding: .6rem .75rem;

        .record_item {
            padding: 1rem;
            background-color: #fff;
            border-radius: .7rem;
            margin-bottom: 1rem;

            .ri {
                display: flex;
                align-items: flex-start;
                margin-bottom: .3rem;

                .prefix {
                    width: 2.8rem;
                    color: #9e9e9e;
                    margin-right: 2.3rem;
                }

                .suffix {
                    flex: 1;
                    color: #000;
                    display: flex;
                    align-items: flex-start;

                    &.cdk {
                        .cdk_num {
                            flex: 1;
                            word-break: break-all;
                        }

                        .fz {
                            color: #9e9e9e;
                            width: 1.4rem;
                            margin-left: 1rem;
                        }
                    }
                }
            }
        }
    }
</style>